import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import basket from './modules/questionBasket';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    questionBasket: basket
  }
});

